import MedicalRecordForm from './medical-record-form';

export default MedicalRecordForm;
